
angular.module('listviewModule').component('listviewColAddressUnit', {
	templateUrl: 'listviewColAddressUnit/listviewColAddressUnit.html',
	bindings: {
		item: '=',
		unitOnly: '<'
	},
	controller: [function() {
	}]
});
